<template>
    <div>
      认证规则查询

      <div @click="handleDetail">点击详情</div>
    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
    }
  },
  methods: {
    handleDetail () {
      this.$router.push({ path: '/authenticationRuleDetail' })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
